module.exports = __webpack_public_path__ + "img/4590.d2735733.jpg";